import { reactive, toRefs } from 'vue';
import crudDataService from "@/Services/crudDataService";

const state = reactive({
  icons: [],
  address: '',
  description_footer: '',
  phone: '551017899',
  logo: '',
  email: 'info@ruc-s.com',
  whatsapp: '551017899',
  link_map: '',
  loaded: false,
});

let fetchPromise = null;

export function useSiteData() {
  async function loadSiteData() {
    if (state.loaded) return;
    if (fetchPromise) return fetchPromise;

    fetchPromise = crudDataService.getAll('icons').then((response) => {
      const data = response.data.data;
      state.icons = data.icons;
      state.address = data.address;
      state.description_footer = data.description_footer;
      state.phone = data.phone;
      state.logo = data.logo;
      state.email = data.email;
      state.link_map = data.link_map;
      state.whatsapp = data.whatsapp;
      state.loaded = true;
    }).catch(() => {
      fetchPromise = null;
    });

    return fetchPromise;
  }

  return {
    ...toRefs(state),
    loadSiteData,
  };
}
